import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { TextInput } from '@womcorp/wom-miwom-ui-kit/dist/components/Input/Formik/index';
import { navigate } from 'gatsby';
import CustomerService from '../../../../services/Customer';
import { FieldTitleStyled as FieldTitle } from '../styles/FormsStyled';

const AffectedNumberField = ({
  helperText,
  label,
  name,
  onChange,
  setError,
}) => {
  const [checking, setChecking] = useState(false);
  const [cache, setCache] = useState({}); // set of valid numbers (true is valid)

  const checkNumber = async number => {
    const error = 'El teléfono ingresado debe ser WOM';
    try {
      if (!/^[0-9]{9}$/.test(number)) return error;
      if (number in cache) return cache[number] ? undefined : error;
      if (!checking) setChecking(true);
      await CustomerService.validateWomNumber(
        `56${number}`,
        'vwn/trouble-ticket/affected-number'
      );
      setCache(prev => ({ ...prev, [number]: true }));
      return undefined;
    } catch (err) {
      if (err?.status === 403) return navigate('/limite-de-intentos');
      if (err?.status === 404 && err?.data?.cellphoneInfo?.isWom === false) {
        setCache(prev => ({ ...prev, [number]: false }));
        return error;
      }
      setError(true);
      return error;
    } finally {
      setChecking(false);
    }
  };

  return (
    <>
      <FieldTitle>Número afectado</FieldTitle>
      <TextInput
        helperText={helperText}
        inputProps={{ maxLength: 9 }}
        label={label}
        loading={checking}
        name={name}
        onChange={e => {
          if (onChange) onChange(e);
          const { value } = e.target;
          e.target.value = value.replace(/[^0-9]/g, '');
        }}
        prefix="+56"
        validate={checkNumber}
      />
    </>
  );
};

AffectedNumberField.propTypes = {
  helperText: PropTypes.string.isRequired,
  label: PropTypes.string.isRequired,
  name: PropTypes.string.isRequired,
  onChange: PropTypes.func,
  setError: PropTypes.func.isRequired,
};

AffectedNumberField.defaultProps = {
  onChange: null,
};

export default AffectedNumberField;
